import React from "react";
import { useState ,useContext} from "react";
import {
  formatIndianAmount,
  formatDaysAgo,
  getDisplayPrice,
} from "../Services/Helper";
import { useNavigate } from "react-router-dom";

import {
  getUserLocation,
  getWishList,
  addtoWishlist,
} from "../Services/Helper";
import { ApiContext } from "../Context/Context";
import { LoggedInUserID } from "../Services/Urls";

const FeaturedPropertiesList =  ({ onheartClick, ...data }) => {
    const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    coordinates,
    setcoordinates,

    searchData,
    setsearchData,wishlist, setWishlist
  } = useContext(ApiContext);
  const navigate = useNavigate();
  const defaultImage = "assets/img/property/property-22.jpg";

  const imageSrc =
    typeof data?.Images === "string" && data.Images.trim() !== ""
      ? data.Images.split(",")[0].trim()
      : defaultImage;

  const handleNavigate = () => {
    const tabID =
      data?.PropertyTypeID === 1 && data?.VerticalID === 1
        ? 384
        : data?.PropertyTypeID === 1 && data?.VerticalID === 2
          ? 385
          : data?.PropertyTypeID === 1 && data?.VerticalID === 3
            ? 386
            : data?.PropertyTypeID === 2 && data?.VerticalID === 1
              ? 387
              : 388;

    navigate(`/property-details?id=${data?.ListingID}`, {
      state: {
        TabID: tabID,
      },
    });
  };

 // const [wishlist, setWishlist] = useState(getWishList() || []);

  const isWishlisted = (data) => {
    return wishlist.some(
      (item) =>
        item.ListingID === data?.ListingID &&
        item.VerticalID === data?.VerticalID &&
        item.PropertyTypeID === data?.PropertyTypeID,
    );
  };

  return (
    <div
      onClick={() => handleNavigate()}
      className="col-lg-3 col-md-4 col-sm-6 col-xs-6 flexcard"
    >
      <div
        className="property-card style4 fcard"
        data-aos="fade-up"
        data-aos-duration={1200}
        data-aos-delay={400}
      >
        <div>
        <div
          
          className="property-img"
        >
          <img src={imageSrc} alt="Property" />
          <span
            className="property-status cursor-pointer"
            // onClick={() => addtoWishlist(data)}
          >
            <i
            onClick={(e) => {
            e.stopPropagation(); // prevents parent click

            if(LoggedInUserID == null){
onheartClick();
            }else{
 addtoWishlist(data, wishlist, setWishlist);

            }
           
          }}
              className="ri-heart-fill"
              style={{
                color: isWishlisted(data) ? "red" : "#ccc",
              }}
            />
          </span>
        </div>
        <div className="property-info">
          <h3>
            <a>{data.Title}</a>
          </h3>
          <p className="locattion">
            <i className="flaticon-location" />
            {data.Locality}
          </p>

          <div className="headss">
            <ul
              className="property-metainfo list-style lst1"
              style={{ marginTop: 10, whiteSpace: "nowrap" }}
            >
              {Array.isArray(data?.UnitFurnishingtitle) &&
                data?.UnitFurnishingtitle?.length > 0 &&
                data?.UnitFurnishingtitle?.slice(0, 3)?.map((title, index) => (
                  <li key={index}>
                    <img
                      src={title?.UnitFurnishingIcon}
                      alt="Furniture"
                      style={{ height: 20, width: 20 }}
                      // className="furnishing-icon"
                    />
                    {title?.Quantity}
                  </li>
                ))}
            </ul>
          </div>
          <p className="property-price">{getDisplayPrice(data)}</p>
        </div>
      </div>
      </div>
    </div>
  );
};

export default FeaturedPropertiesList;
